/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const MarkOutcome = zod.object({
  outcome: zod
    .enum(['created', 'redone', 'undone', 'unchanged'])
    .describe(
      'created: a new mark. redone: an undone mark is done again. undone: done marks of this group are undone. unchanged: nothing to write.',
    ),
});

export type MarkOutcome = zod.input<typeof MarkOutcome>;
export type MarkOutcomeOutput = zod.output<typeof MarkOutcome>;
